import { io } from 'socket.io-client';
import axios from 'axios';

import useAppStore from '../store/useAppStore'
import useAuthStore from '../store/useAuthStore';
import { forceSessionEnd } from '../auth/sessionLifecycle';

const baseUrl = import.meta.env.VITE_API_BASE_URL;

export const socket = io(baseUrl, {
    autoConnect: false,
    withCredentials: true,
});

socket.on('connect', () => {
    console.log('socket connected:', socket.id);
});

socket.on('presenceUpdate', (data) => {
    const { setPresenceLog } = useAppStore.getState();
    setPresenceLog(data.userId, data.presenceLogs, data.newStatus, data.presenceType);
});

socket.on('autoLogoutEmployees', (data) => {
    const { syncPresenceLogs } = useAppStore.getState()
    syncPresenceLogs(data)
});


socket.on('autoLogoutEmployees12', (data) => {
    const { syncPresenceLogsWithCalculation } = useAppStore.getState()
    syncPresenceLogsWithCalculation(data)
});

socket.on('deviceStatusUpdate', (data) => {
    const { deviceStatusUpdate } = useAppStore.getState()
    deviceStatusUpdate(data)
})

socket.on('deviceUpdate', (data) => {
    const { handleDeviceUpdate } = useAppStore.getState()
    handleDeviceUpdate(data)
})

socket.on('employeeDayLogTimeUpdate', (result) => {
    const { handleEmployeeDayLogTimeUpdate } = useAppStore.getState()
    handleEmployeeDayLogTimeUpdate(result)
})

socket.on('absenceUpdate', (data) => {
    const { handleNewAbsence } = useAppStore.getState()
    handleNewAbsence(data.absence)
})

socket.on('absenceModify', (data) => {
    const { handleAbsenceModify } = useAppStore.getState()
    handleAbsenceModify(data.absence)
})

socket.on('absenceDelete', (data) => {
    const { handleAbsenceDelete } = useAppStore.getState()
    handleAbsenceDelete(data.absence_id)
})

socket.on('employeeDelete', (data) => {
    const { handleEmployeeDelete } = useAppStore.getState()
    handleEmployeeDelete(data.userId)
})

socket.on('employeeUpdate', (data) => {
    const { handleEmployeeUpdate } = useAppStore.getState()
    console.log('employeeUpdate', data);
    handleEmployeeUpdate(data)
})

socket.on('employeeCreate', (data) => {
    const { handleEmployeeCreate } = useAppStore.getState()
    handleEmployeeCreate(data)
})

socket.on('unknownRfidTag', (data) => {
    const { handleUnknownRfidTag } = useAppStore.getState()
    handleUnknownRfidTag(data)
})

socket.on('absenceConfirm', (data) => {
    const { handleAbsenceConfirm } = useAppStore.getState()
    console.log('absenceConfirm', data);
    handleAbsenceConfirm(data.absence)
})

socket.on('absenceReject', (data) => {
    const { handleAbsenceReject, hasHR } = useAppStore.getState();
    const { userRole, userId, isHR } = useAuthStore.getState();
    const absenceUserId = data.absence?.user_id;
    const shouldKeepRejected = String(userId) === String(absenceUserId) || (hasHR ? isHR : userRole === 'admin');

    handleAbsenceReject(data.absence, shouldKeepRejected);
})

socket.on('newNotification', (notification) => {
    const { addNotification } = useAppStore.getState()
    addNotification(notification)
})

socket.on('disconnect', (reason) => {
    console.log('socket disconnected:', reason);
    forceSessionEnd({ reason: `socket_disconnect:${reason || 'unknown'}` });
});

socket.on('connect_error', (error) => {
    console.error('socket connect_error:', error?.message || error);
    forceSessionEnd({ reason: 'socket_connect_error' });
});

socket.on('proba', (data) => {
    // console.log('Proba data received 1:');
    // console.log(data.logs);
    // console.log('Proba data received 2:');
    // console.log(data.userLogs);
    console.log('asdasdasdasdasasdsa');

    console.log(data);

});

export const connectSocket = async () => {
    try {
        const response = await axios.get(`${baseUrl}/api/auth/me`, {
            withCredentials: true,
            skipSessionHandler: true
        });
        if (response?.status === 200) {
            socket.connect(); // Poveži se SAMO ako je korisnik ulogovan
        }
    } catch (err) {
        console.error('Not authenticated', err);
    }
};